import { Injectable } from '@angular/core';
import io from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class SocketServiceService {
  socketUrl:any;
  socket:any;
  constructor(private toastr: ToastrService) { }
  connect() {
    // this.socket = io({
    //   path: "/ws",
    //   transports: ["websocket", "polling"],
    // });
  //   this.socket.on("connect", () => {
  //     console.log("connect", );
  //   });
  //   this.socket.on("disconnect", (disconnect) => {
  //     console.log("disconnect", disconnect);
  //   });
  //   this.socket.on("waes_data-AWSMarketplace" , (message) => {
  //     console.log("new_message", message);
  //     if(message && message.status==200){
  //     this.toastr.success(message.info, 'Success', { timeOut: 8000 })
  //     localStorage.setItem('whatsappEmbeddedLogin','')
  //     }else{
  //       let ErrorText = message && message.info ? message.info :'Something went wrong!'
  //       this.toastr.error(ErrorText, 'Error', { timeOut: 8000 })
  //       localStorage.setItem('whatsappEmbeddedLogin','')
  //     }
  //   });

  }
  // disconnect() {
  //   this.socket.close();
  // }
  // getMessage(): Observable<any> {
  //   return new Observable((observer) => {
  //     this.socket.on("waes_data-AWSMarketplace" ,(message:any) => {
  //       observer.next(message);
  //       console.log("message from socket", message)
  //     });
  //   });
  // }
}
